import { render, staticRenderFns } from "./mxactivity.vue?vue&type=template&id=95c68344&"
import script from "./mxactivity.vue?vue&type=script&lang=js&"
export * from "./mxactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports